import React from 'react';
import { useTabLayout } from '../hooks/useTabLayout';

type TabLayoutContainerProps = { children: React.ReactNode };

const TabLayoutContainer = ({ children }: TabLayoutContainerProps) => {
	const { blockClass } = useTabLayout();
	return (
		<div
			className={`container ${blockClass ? `container--${blockClass} vtex-tab-layout-0-x-container--${blockClass}` : ''} vtex-tab-layout-0-x-container`}
		>
			{children}
		</div>
	);
};

export default TabLayoutContainer;
